import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 51137 34321"
    {...props}
  >
    <path
      d="M50766 31493c0 724-318 1440-929 1925-1063 844-2607 666-3451-398L25568 6778 4751 33020c-845 1062-2388 1241-3451 398-1064-843-1241-2387-398-3451L23644 1301c466-587 1175-930 1924-930s1459 343 1925 930l22742 28666c358 453 531 991 531 1526z"
      style={{
        fill: "#2b2a29",
        stroke: "#2b2a29",
        strokeWidth: 741.126,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
